import { RESULTS } from "@/data/content";
import { Reveal } from "@/components/site/Reveal";

export const Results = () => (
  <section
    id="resultater"
    data-testid="results-section"
    className="bg-[#ffffff] text-[#141414] py-28 md:py-40"
  >
    <div className="mx-auto max-w-[1400px] px-6 md:px-12">
      <Reveal>
        <p className="font-ui text-[11px] uppercase tracking-[0.3em] text-[#1f3d2b] mb-6 flex items-center gap-3">
          <span className="inline-block h-px w-8 bg-[#1f3d2b]" />
          Resultater
        </p>
        <h2 className="font-display font-light leading-[1.05] text-4xl md:text-5xl lg:text-6xl mb-16 md:mb-24 max-w-3xl">
          Tal, der taler til en bestyrelse.
        </h2>
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#e4e4e1] border border-[#e4e4e1]">
        {RESULTS.map((r, i) => (
          <Reveal key={i} delay={(i % 3) * 0.08} className="bg-white">
            <div
              data-testid="result-tile"
              className="p-8 md:p-10 h-full flex flex-col justify-between min-h-[220px] hover:bg-[#f4f4f2] transition-colors duration-300"
            >
              <div className="font-display font-light text-6xl md:text-7xl leading-[0.95] text-[#1f3d2b]">
                {r.value}
              </div>
              <div className="mt-6">
                <div className="font-ui text-sm uppercase tracking-[0.16em] text-[#141414]">
                  {r.unit}
                </div>
                <div className="mt-1 font-ui text-sm text-[#6f6f6a]">
                  {r.label}
                </div>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
